<div class="hea">
  <button
    type="button"
    class="hea-toggle"
    [attr.aria-expanded]="expanded"
    [attr.aria-controls]="panelId"
    (click)="toggleExpanded()"
  >
    <span>{{ lang.translate('home.entityActions.toggle') }}</span>
    <span class="hea-caret" [class.is-open]="expanded" aria-hidden="true">&#9662;</span>
  </button>

  <div class="hea-panel" [id]="panelId" *ngIf="expanded">
    <!-- H10 - preguntas sugeridas -->
    <div
      class="hea-block"
      role="group"
      [attr.aria-label]="lang.translate('home.entityActions.questionsTitle')"
    >
      <p class="hea-subtitle">{{ lang.translate('home.entityActions.questionsTitle') }}</p>

      <div class="hea-loading" role="status" *ngIf="questionsLoading">
        {{ lang.translate('home.general.loading') }}
      </div>

      <div class="hea-error" *ngIf="questionsError">
        <span>{{ lang.translate('home.entityActions.questionsError') }}</span>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="retryQuestions()">
          {{ lang.translate('home.general.retry') }}
        </button>
      </div>

      <p class="hea-empty" *ngIf="questionsEmpty">
        {{ lang.translate('home.entityActions.questionsEmpty') }}
      </p>

      <ul class="hea-chips" *ngIf="!questionsLoading && !questionsError && questions.length">
        <li *ngFor="let q of questions; trackBy: trackQuestion">
          <button type="button" class="hea-chip" [title]="q.category" (click)="onQuestionSelected(q)">
            {{ q.text }}
          </button>
        </li>
      </ul>
    </div>

    <!-- H11 - preguntar sobre esta entidad (entrada al chat, envio manual) -->
    <button type="button" class="hea-action" (click)="onAskAboutEntity()">
      {{ lang.translate('home.entityActions.askAboutEntity') }}
    </button>

    <!-- H12 - generar documento (gated doc_generation) con confirmacion explicita de fuentes -->
    <ng-container *ngIf="docGenerationEnabled">
      <button
        type="button"
        class="hea-action"
        *ngIf="!showSourcesPreview"
        [attr.aria-expanded]="showSourcesPreview"
        (click)="onGenerateClicked()"
      >
        {{ lang.translate('home.entityActions.generate') }}
      </button>

      <div
        class="hea-block hea-sources"
        *ngIf="showSourcesPreview"
        role="group"
        [attr.aria-label]="lang.translate('home.entityActions.sourcesTitle')"
      >
        <p class="hea-subtitle">{{ lang.translate('home.entityActions.sourcesTitle') }}</p>

        <div class="hea-loading" role="status" *ngIf="sourcesLoading">
          {{ lang.translate('home.general.loading') }}
        </div>

        <div class="hea-error" *ngIf="sourcesError">
          <span>{{ lang.translate('home.entityActions.sourcesError') }}</span>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="retrySources()">
            {{ lang.translate('home.general.retry') }}
          </button>
        </div>

        <p class="hea-empty" *ngIf="sourcesEmpty">
          {{ lang.translate('home.entityActions.sourcesEmpty') }}
        </p>

        <ul class="hea-source-list" *ngIf="!sourcesLoading && !sourcesError && sources.length">
          <li class="hea-source" *ngFor="let s of sources; trackBy: trackSource">
            <span class="hea-source-name">{{ s.filename }}</span>
            <span class="hea-source-meta">
              {{ s.type }} &middot; {{ lang.translate('home.entityActions.version') }} {{ s.versionNo }}
            </span>
            <span class="hea-source-reason" *ngIf="s.reason">{{ s.reason }}</span>
          </li>
        </ul>

        <div class="hea-actions-row">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            [disabled]="!canConfirmGeneration"
            (click)="confirmGeneration()"
          >
            {{ lang.translate('home.entityActions.sourcesConfirm') }}
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelGeneration()">
            {{ lang.translate('home.entityActions.cancel') }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
